import { NotificationRequest, Notification, Answer, AnswerRequest, FileAttachment, TNotificationRequestTarget } from '@/interfaces/files';
import { GetUnreadCount } from '@/interfaces/notification';
import { AxiosPromise } from 'axios';
import request from '@/umi-request';

export async function uploadAttachment(data: any) {
  return request({
    url: `affiliate-notifications/upload-attachment/`,
    method: 'POST',
    data
  }) as AxiosPromise<FileAttachment>
}

export async function queryNotifications(params: any) {
  return request({
    url: 'notifications/',
    method: 'GET',
    params
  }) as AxiosPromise<Notification[]>;
}

export async function getUnreadCount() {
  return request({
    url: 'notifications/unread-count/',
    method: 'GET',
  }) as AxiosPromise<GetUnreadCount>;
}

export async function markNotificationRead(id: number | string) {
  return request({
    url: `notifications/${id}/mark_read/`,
    method: 'POST',
  }) as AxiosPromise<Notification>;
}

export async function clearNotifications() {
  return request({
    url: 'notifications/mark_all_deleted/',
    method: 'POST',
  }) as AxiosPromise<Notification>;
}

export async function createNotification(data: NotificationRequest) {
  return request({
    url: `affiliate-notifications/`,
    method: 'POST',
    data
  }) as AxiosPromise<Notification>;
}

export async function createAnswer(data: AnswerRequest) {
  return request({
    url: `affiliate-answers/`,
    method: 'POST',
    data
  }) as AxiosPromise<Answer>;
}

export async function createNotificationToTarget(data: NotificationRequest, target: TNotificationRequestTarget) {
  return request({
    url: `files/${data.file}/${target}/${data.id}/create_notification/`,
    method: 'POST',
    data
  }) as AxiosPromise<Notification>;
}